const Scrap = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.6639 4H10.1494C7.85685 4 6 5.82886 6 8.08685V25.1699C6 27.3972 8.51037 28.7458 10.4191 27.5504L16 24.0971L21.5809 27.5504C23.5 28.7458 26 27.3768 26 25.1392V8.08685C26 5.82886 24.1432 4 21.8506 4H21.6639Z"
        fill="#FFC61C"
      />
    </svg>
  );
};

export default Scrap;
